import Raphael from 'raphael';
import ScrollReveal from 'scrollreveal';
import './lib/rafael-connection';

window.sr = ScrollReveal();

const RECT_SIZE = 1;
const DURATION = 900;
const SCALE = 0.8;

$(() => {
  sr.reveal('#smart-contract', {
    duration: DURATION,
    viewFactor: 0.5,
    scale: SCALE
  });

  sr.reveal('.messages__smart-contract-img', {
    duration: DURATION,
    viewFactor: 0.5,
    scale: SCALE
  });

  buildLines();
  $(window).resize(rebuildLines);
});

let isDrawn = false;

const buildLines = (isRebuild) => {
  const $howWorkMessages = $('#how-work-messages');

  if (!$howWorkMessages.length) {
    return;
  }

  const $holder = $('#holder');

  $holder.html('');

  const { left, top } = $howWorkMessages;
  $holder.css({ position: 'absolute', left, top });

  const paper = Raphael(
    'holder',
    $howWorkMessages.width(),
    $howWorkMessages.height(),
  );

  const createPoint = (x, y) => {
    const point = paper.rect(x, y, RECT_SIZE, RECT_SIZE);
    point.attr({ stroke: '#f5f5f5', "fill-opacity": 0, "stroke-width": 2 });
    return point;
  };

  const connectionShape = (from, to, duration) => {
    const { line } = paper.connection(from, to, '#6fda44');
    const params = { 'stroke-width': 6 };

    if (duration > 0) {
      line.animate(params, duration);
    } else {
      line.attr(params);
    }
  };

  const createCenterPoint = () => {
    return createPoint(
      $howWorkMessages.width() / 2,
      $howWorkMessages.height() / 2
    );
  };

  const createPointBetweenMessage = ($smartContractImage) => {
    const { left, top } = $smartContractImage.position();
    const x = left + $smartContractImage.outerWidth(true) / 2;
    const y = top + $smartContractImage.outerHeight(true) / 2;
    return createPoint(x, y);
  };

  const messageShapes = $.map($('.message'), (message) => {
    const $message = $(message);
    
    let { left: x, top: y } = $message.position();
    
    x += $message.hasClass('message_right') ? $message.outerWidth(true) - 70 : 70;
    y += $message.outerHeight(true) / 2.3;
    
    const shape = createPoint(x, y);
    
    const $messages = $message.parent();
    if($messages.css('display') === 'none'){
      return;
    }

    const $smartContractImage = $messages.find('.messages__smart-contract');
    const connectToPoint = $smartContractImage.is(':visible') 
                            ? createPointBetweenMessage($smartContractImage) 
                            : createCenterPoint();

    sr.reveal(message, {
      duration: DURATION,
      viewFactor: 0.6,
      scale: SCALE,
      beforeReveal: () => {
        setTimeout(() => {
          isDrawn = true;
          connectionShape(shape, connectToPoint, DURATION / 2);
        }, DURATION / 2);
      }
    }, 50);

    return { shape, connectToPoint };
  });

  if (isRebuild && isDrawn) {
    messageShapes.forEach(({ shape, connectToPoint }) => {
      connectionShape(shape, connectToPoint, 0);
    });
  }
}

const rebuildLines = () => {
  requestAnimationFrame(buildLines);
}